import React from 'react';
import inView from 'in-view';
import luxy from 'luxy.js';
import scrollama from 'scrollama';
import axios from 'axios';
import { db } from '../../services/auth';
import {
	Nav, Header, Team, About, Vision, Study, Areas,
	Contact, Location, Footer, isMobileOrTablet, LoadingAnimation } from '../../components';
import { Where } from '../../components/Sections';

export default class Home extends React.Component {
	state = { loading: true, website: { phone: '' }, sent: false };

	async componentDidMount() {
		this.scrolled = false;
		this.nav = document.querySelector('.header__nav');
		window.addEventListener('scroll', this.onScroll, {passive: true});
		inView.offset(50);
		document.body.style.overflow = 'hidden';
		axios.get('/api/website').then(res => {
			console.log(res);
			this.setState({loading: false, website: res.data}, _ => {
				this._loading && this._loading.close(_ => {
					document.body.style.overflow = 'auto';
					this.addAnimations();
				});
			});
		}).catch(err => {
			console.log(err);
			this.setState({loading: false}, _ => {
				this._loading && this._loading.close(_ => {
					document.body.style.overflow = 'auto';
					this.addAnimations();
				});
			});
		});
	}

	addAnimations = _ => {
		inView('.in_view_animate').on('enter', el => {
			el.classList.add('scrolled');
		});
		if (isMobileOrTablet) return;
		luxy.init();
		const scroller = scrollama();
		scroller
		.setup({ step: '[data-step]'})
		.onStepEnter(({element}) => {
			var navItem = this.nav.querySelector(`[data-to='${element.getAttribute('data-step')}']`);
			var active = this.nav.querySelector('li.active');
			if (active) active.classList.remove('active');
			navItem.parentNode.classList.add('active');
		});
	}

	onScroll = _ => {
		var scrollY = window.scrollY;
		if (!this.scrolled && scrollY > 100){
			this.nav.classList.add('scrolled');
			this.scrolled = true;
		}
		if (this.scrolled && scrollY <= 100){
			this.nav.classList.remove('scrolled');
			this.scrolled = false;
		}
	}

	handleSection = (ev) => {
		var currentTarget = ev.currentTarget;
		var target = document.querySelector(currentTarget.getAttribute('data-to'));
		if (!target) return;
		if (isMobileOrTablet){
			var active = this.nav.querySelector('li.active');
			if (active) active.classList.remove('active');
			currentTarget.parentNode.classList.add('active');
		}
		var top = target.offsetTop - window.scrollY;
		this.nav.classList.remove('active');
		window.scrollBy({ top: top - 50, left: 0, behavior: 'smooth' });
	}

	handleMenu = _ => {
		this.nav.classList.toggle('active');
	};

	onSendMessage = async ev => {
		ev.target.disabled = true;
		ev.target.innerText = "Enviando...";
		var name = document.getElementById('contact-name').value.trim();
		var from = document.getElementById('contact-email').value.trim();
		var subject = document.getElementById('contact-subject').value.trim();
		var content = document.getElementById('contact-content').value.trim();
		var message = { name, from, subject, content };
		try {
			var result = await db.post('website/email', message, true)
			console.log(result);
			this.setState({sent: true});
		} catch(err){
			alert(err.message);
			console.log(err);
			this.setState({sent: true});
		}
	}

	render(){
		var { website, sent, loading } = this.state;
		return (
			<div>
				<LoadingAnimation ref={r => this._loading = r} />
				<Nav handleMenu={this.handleMenu} phone={website.phone} handleSection={this.handleSection} />
				{!loading && (
					<div id="luxy">
						<div data-step=".section__header">
							<Header
								phone={website.phone}
								title={website.title}
								image={website.headerImageId}
								subtitle={website.subtitle}
								handleSection={this.handleSection} />
							<Where title={website.whereTitle}></Where>
							<About title={website.aboutTitle} images={website.websiteImage} description={website.about} />
							<Vision
								title={website.visionTitle}
								description={website.vision}
								name={website.signatureName}
								position={website.signaturePosition} />
						</div>
						<div data-step=".study">
							<Study
								image={website.studyImageId}
								title={website.studyTitle}
								description={website.study}
								text1={website.studyText1}
								text2={website.studyText2} />
							<Team users={website.user} title={website.userTitle} />
						</div>
						<div data-step=".wp-section-areas">
							<Areas areas={website.area} title={website.areaTitle} />
						</div>
						<div data-step=".contact">
							<Contact onSendMessage={this.onSendMessage} phone={website.phone} sent={sent} title={website.contactTitle} text={website.contactText} />
							<Location phone={website.phone} email={website.email} address={website.address} />
							<Footer />
						</div>
					</div>
				)}
			</div>
		);
	}
}
